import React, { useState, useEffect } from "react"
import "./OrderList.css"
import { Form, FormGroup, Label, Input, Button } from "reactstrap"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const OrderList = () => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [courseList, setCourseList] = useState([])
  const [courseId, setCourseId] = useState("")
  const [orderList, setOrderList] = useState([])
  const [courseType, setCourseType] = useState("")
  const [paymentType, setPaymentType] = useState("")
  const [selectedCourse, setSelectedCourse] = useState("")

  const [state, setState] = useState({
    formData: {
      fromDate: "",
      toDate: "",
      courseId: "",
      courseType: "",
      paymentType: "",
    },
  })

  const stringifyUser = localStorage.getItem("authUser")
  //const authUser = stringifyUser !== null ? JSON.parse(stringifyUser) : null

  const [user, setUser] = useState(
    stringifyUser !== null ? JSON.parse(stringifyUser) : null
  )

  const getCourse = () => {
    fetch(`${process.env.REACT_APP_URL}/api/instructor/course/${user?._id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setCourseList(data?.data?.course)
      })
      .catch(err => console.log(err?.response?.data))
  }

  useEffect(() => {
    getCourse()
  }, [user])

  useEffect(() => {
    const data = state.formData
    data.fromDate = startDate ? new Date(startDate).toISOString() : null
    data.toDate = endDate ? new Date(endDate).toISOString() : null
    data.courseId = courseId ? courseId : null
    data.courseType = courseType ? courseType : null
    data.paymentType = paymentType ? paymentType : null
    console.log(data)

    const params = new URLSearchParams()
    if (data.fromDate) params.append("fromDate", data.fromDate)
    if (data.toDate) params.append("toDate", data.toDate)
    if (data.courseId) params.append("courseId", data.courseId)
    if (data.courseType) params.append("courseType", data.courseType)
    if (data.paymentType) params.append("paymentType", data.paymentType)

    fetch(
      `${process.env.REACT_APP_URL}/new/api/instructor/payment/all/earnings/${
        user?._id
      }?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
      .then(res => res?.json())
      .then(data => {
        console.log("orderListData", data)
        setOrderList(data)
        if (data?.success) {
          // toastr.success(data?.message, "Order")
        } else {
          // toastr.error(data?.message, "Order")
        }
      })
      .catch(err => toastr.error(err?.response?.data?.message, "Order"))
  }, [startDate, endDate, courseId, courseType, paymentType])

  return (
    <div className="orderDiv">
      <h3>Order List</h3>
      <Form>
        <FormGroup>
          <Label for="SelectCourseTitle">Course Title</Label>
          <Input
            name="courseTitle"
            type="select"
            onChange={e => {
              setCourseId(e.target.value)
              setSelectedCourse(
                courseList?.find(course => course._id === e.target.value)
                  ?.title || ""
              )
            }}
          >
            <option value="">All Courses</option>
            {courseList?.map(course => (
              <option key={course?._id} value={course._id}>
                {course.title}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label className="mt-3" for="startingDate">
            Starting Date
          </Label>
          <Input
            id="startingDate"
            name="startingDate"
            placeholder="date placeholder"
            type="date"
            onChange={e => setStartDate(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label className="mt-3" for="endingDate">
            Ending Date
          </Label>
          <Input
            id="endingDate"
            name="endingDate"
            placeholder="date placeholder"
            type="date"
            onChange={e => setEndDate(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label className="mt-3" for="courseType">
            Course Type
          </Label>
          <Input
            id="courseType"
            name="courseType"
            type="select"
            onChange={e => setCourseType(e.target.value)}
          >
            <option value="">All</option>
            <option value="SINGLE">Single</option>
            <option value="BUNDLE">Bundle</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label className="mt-3" for="paymentType">
            Payment Type
          </Label>
          <Input
            id="paymentType"
            name="paymentType"
            type="select"
            onChange={e => setPaymentType(e.target.value)}
          >
            <option value="">All</option>
            <option value="ONLINE">Online</option>
            <option value="MANUAL">Manual</option>
          </Input>
        </FormGroup>
      </Form>
      {orderList ? (
        <div className="mt-3 mt-5">
          <h4 className="mt-3">
            {courseId
              ? `Order List for Course: ${selectedCourse}`
              : "All Orders"}
          </h4>
          <h4 className="mt-3">
            Total Order Found: {orderList?.data?.totalDocuments}
          </h4>
          <h4 className="mt-3">
            Total Earning: {orderList?.data?.totalEarnings}
          </h4>
          <div>
            <table className="table table-striped table-hover">
              <thead className="thead  tablehead">
                <tr>
                  <td scope="col">#</td>
                  <td scope="col">Course Name</td>
                  <td scope="col">Date</td>
                  <td scope="col">User</td>
                  {/* <td scope="col">Email</td>
                  <td scope="col">Phone</td> */}
                  <td scope="col">Price</td>
                  <td scope="col">Trainer Amount</td>
                  {/* <td scope="col">TrxId</td> */}
                  {/* <td scope="col">Payment</td> */}
                </tr>
              </thead>

              <tbody className="tablebody">
                {orderList?.data?.instructorEarnings?.map((order, index) => {
                  return (
                    <tr key={index}>
                      <td data-label="No" className="align-middle">
                        {index + 1}
                      </td>
                      <td data-label="Course Name" className="align-middle">
                        {order?.courseName}
                      </td>
                      <td
                        data-label="Transaction Date"
                        className="align-middle"
                      >
                        {order?.createdAt.slice(0, 10)}
                      </td>
                      <td data-label="Customer Name" className="align-middle">
                        {order?.studentName}
                      </td>
                      {/* <td data-label="Customer Email" className="align-middle">
                        {order.customerInfo.cusEmail}
                      </td> 
                      <td
                        data-label="Customer Phone No"
                        className="align-middle"
                      >
                        {order.customerInfo.cusPhone}
                      </td> */}
                      <td data-label="Ammount" className="align-middle">
                        {order?.orderAmount}
                      </td>
                      <td data-label="Trainer amount">
                        {order?.instructorPayableAmount}
                      </td>
                      {/* <td data-label="TrxId" className="align-middle">
                        {order?.transactionId}
                      </td> */}
                      {/* <td data-label="Payment" className="align-middle">
                        {order.paymentDone ? "Success" : "Failed"}
                      </td> */}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default OrderList
